/** @format */

interface Options {
  startDate?: string;
  endDate: string;
}

const generateLink = ({startDate, endDate}: Options) => {
  return `/home/ya-direct-change-log?startDate=${startDate || endDate}&endDate=${endDate}`;
};

export {generateLink};
